import React, { Fragment, useState, useEffect } from "react";
import MainFilter from "../components/filters/MainFilter";
import { setComparisonFilter } from "../redux/actions/comparisonActions";
import { useSelector, useDispatch } from "react-redux";
import { comparisonRequest } from "../helpers/requests";
import moment from "moment";
import { getWeeks } from "../redux/reducers/comparisonReducer";
import CompareHeader from './Templates/CompareHeader';
import CompareSingle from "./Templates/CompareSingle";
import CompareMultiple from "./Templates/CompareMultiple";
import { Card, CardBody, Row, Col, Progress, Table } from "reactstrap";
import Select from 'react-select';


const Comparison = () => {
  const [filters, setFilters] = useState();
  const [compareTypes, setCompareTypes] = useState("single");
  var comparison = useSelector(state => state.compare.groupComparison);
  const dispatch = useDispatch();

  const updateFilter = (e) => {


    console.log('eeeee',e);

    var requestData = {
      params: e,
      dispatch,
    };
    comparisonRequest(requestData);
    setFilters(e);
  };

  const language = "english";
  const time_zone = localStorage.getItem("timeZone");
  const user = useSelector((state) => state.auth.user);
  const stores = user.access.map((val, index) => {
    return { ...val, value: val._id, label: val.label };
  });
  const [storeToBeCompare1, setStoreToBeCompare1] = useState()
  const [storeToBeCompare2, setStoreToBeCompare2] = useState()
  const [comparisonFormatData, setComparisonFormatData] = useState([]);
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected ? "#fd7e14" : '',
      boxShadow: "0px 4px 37px 9px rgb(0 0 0 / 3%)",
      borderRadius: "0px",
    }),
    control: (provided) => ({
      ...provided,
      height: "40px",
      background: "#FFFFFF",
      boxShadow: "0px 4px 37px 9px rgb(0 0 0 / 3%)",
      borderRadius: "4px",
      border: "1px solid  #ced4da",
      width: 200,

    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10
    })
  }

  const getProgressDifference = (item) => {


  }

  useEffect(() => {
    if (comparison) {
      let data = { 0: [], 1: [] };
      //  data[0] = payload[state.filter.store._id];
      //  data[1] = payload[state.filter.cstore._id];
      if (filters) {
        data[0] = comparison[filters.sid[0]][0];
        data[1] = comparison[filters.sid[1]][0]
      }
      setComparisonFormatData(data)

    }

  }, [comparison])




  useEffect(() => {
    setTimeout(() => {
      // getComparison();
    }, 200);
  }, []);

  return (
    <Fragment>
      <Row>
        <Col>
          <MainFilter
            pageTitle="Comparisons"
            updateFilter={(e) => updateFilter(e)}
            compareType={"multiple"}
            type='compareMultiple'

          ></MainFilter>
        </Col>
      </Row>
      <Row>
        {/* <Card> */}
        <Table className="table-bordered">
          <tbody>
            <tr>
              <td className='text-center ' >
                <div className='p-2'>
                  Keys
                </div></td>
              <td className="">
                <Row >
                  <Col md={1}>
                  </Col>
                  <Col md={3} className='text-center' >
                    <div className='p-2' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {filters?.selected?.storeName}

                      {/* <Select
                          options={stores}
                          value={storeToBeCompare1}
                          onChange={(val) => setStoreToBeCompare1(val)}
                          styles={customStyles}
                        /> */}

                    </div>

                  </Col>
                  <Col md={4} className='text-center p-2' >
                    {"Vs"}
                  </Col>
                  <Col md={3}>
                    <div className='p-2' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {filters?.selected?.secondStore}
                      {/* <Select
                        options={stores}
                        value={storeToBeCompare2}
                        onChange={(val) => setStoreToBeCompare2(val)}
                        styles={customStyles}

                      /> */}

                    </div>
                  </Col>
                  <Col md={1} className='text-center' >
                  </Col>
                </Row>
              </td>
            </tr>
          </tbody>
          <tbody>
            {Object.keys(comparisonFormatData).length && Object.keys(comparisonFormatData[0] ? comparisonFormatData[0] : {})?.map((item) => {
              if (item != "_id") {
                return (
                  <tr>
                    <td className='text-center'>
                      {item}
                    </td>
                    <td className='text-center'>
                      <Row>
                        <Col md={1}>
                        </Col>
                        <Col md={3}>
                          {comparisonFormatData[0][item]}
                        </Col>
                        <Col md={4}>
                          {/* <div className="progress">
                        <div className="progress-bar" role="progressbar"  style={{width : "20%" ,ariaValuenow : "20",ariaValuemin : "0",  ariaValuemax: "100" }}></div>
                        <div className="progress-bar bg-success" role="progressbar" style={{width : "20%" ,ariaValuenow : "20",ariaValuemin : "0",  ariaValuemax: "100" }}></div>
                        <div className="progress-bar bg-info" role="progressbar" style={{width : "20" ,ariaValuenow : "20",ariaValuemin : "0",  ariaValuemax: "100" }}></div>
                      </div> */}
                          <Row>
                            <Col md={1} className='mx-2'>
                              {(comparisonFormatData[0][item] / (comparisonFormatData[0][item] + comparisonFormatData[1][item]) * 100).toFixed() + "%"}
                            </Col>
                            <Col md={9} className='p-2 ml-2'>
                              <div className="progress " style={{ height: "0.5rem" }}>
                                <div className="primaryColor progress-bar  " role="progressbar" style={{ width: (comparisonFormatData[0][item] / (comparisonFormatData[0][item] + comparisonFormatData[1][item]) * 100).toFixed() + "%", ariaValuenow: (comparisonFormatData[0][item] / (comparisonFormatData[0][item] + comparisonFormatData[1][item]) * 100).toFixed(), ariaValuemin: "0", ariaValuemax: "100" }}  ></div>
                                <div className="primaryLight progress-bar " role="progressbar" style={{ width: (comparisonFormatData[1][item] / (comparisonFormatData[0][item] + comparisonFormatData[1][item]) * 100).toFixed() + "%", ariaValuenow: (comparisonFormatData[1][item] / (comparisonFormatData[0][item] + comparisonFormatData[1][item]) * 100).toFixed(), ariaValuemin: "0", ariaValuemax: "100" }}  ></div>
                              </div>
                            </Col>
                            <Col md={1} className=''>
                              {(comparisonFormatData[1][item] / (comparisonFormatData[0][item] + comparisonFormatData[1][item]) * 100).toFixed() + "%"}

                            </Col>


                          </Row>

                        </Col>
                        <Col md={3}>
                          {comparisonFormatData[1][item]}

                        </Col>
                      </Row>
                    </td>
                  </tr>
                )
              }
            }
            )}


          </tbody>
        </Table>
        {/* </Card> */}

      </Row>






    </Fragment>
  );
};

export default Comparison;
